import { Mail, Phone } from "lucide-react";
import type { CrmContact } from "@/lib/api/crm/masters";
import { formatPhoneForDisplay } from "@/lib/validation/phoneNumber";
import { TagList } from "./TagList";

export function ContactList({ contacts }: { contacts: CrmContact[] }) {
  if (contacts.length === 0) {
    return <p className="text-sm text-gray-400">No contacts yet</p>;
  }

  return (
    <ul className="space-y-3">
      {contacts.map((contact) => {
        const isPhone = contact.kind === "phone";
        const Icon = isPhone ? Phone : Mail;
        return (
          <li key={contact.id} className="flex items-start gap-3" data-testid={`crm-contact-${contact.id}`}>
            <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-white text-gray-500 ring-1 ring-gray-200">
              <Icon className="h-4 w-4" />
            </span>
            <div className="min-w-0 flex-1">
              <a
                href={isPhone ? `tel:${contact.value}` : `mailto:${contact.value}`}
                className="block truncate text-sm font-medium text-gray-900 hover:text-blue-700 hover:underline"
              >
                {isPhone ? formatPhoneForDisplay(contact.value) : contact.value}
              </a>
              {contact.label && <p className="text-xs text-gray-500">{contact.label}</p>}
              <TagList tags={contact.tags} />
            </div>
          </li>
        );
      })}
    </ul>
  );
}
